import { render, staticRenderFns } from "./sidedata.vue?vue&type=template&id=484e4660&scoped=true&"
import script from "./sidedata.vue?vue&type=script&lang=js&"
export * from "./sidedata.vue?vue&type=script&lang=js&"
import style0 from "./sidedata.vue?vue&type=style&index=0&id=484e4660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e4660",
  null
  
)

export default component.exports